export interface Event {
  id: string;
  slug: string;
  title: string;
  date: string;
  time: string;
  endTime?: string;
  location: string;
  description: string;
  category: string;
  attendeeCount: number;
  maxAttendees?: number;
  organizer: string;
  tags: string[];
  isPrivate: boolean;
  imageGradient?: string;
}

export const mockEvents: Event[] = [
  {
    id: 'evt-1',
    slug: 'yoga-pool-deck-march',
    title: 'Yoga on the Pool Deck',
    date: 'Saturday, March 29, 2026',
    time: '7:30 AM',
    endTime: '8:45 AM',
    location: 'Tower 1 Pool Deck, Level 8',
    description:
      'Start your Saturday morning with a guided vinyasa flow session on the pool deck. All levels welcome. Bring your own mat — blocks and straps available. Limited to 20 residents. This is a resident-only event hosted by our in-building wellness community.',
    category: 'Fitness & Wellness',
    attendeeCount: 14,
    maxAttendees: 20,
    organizer: 'Priya Mehta',
    tags: ['Yoga', 'Wellness', 'Morning', 'Pool Deck'],
    isPrivate: true,
    imageGradient: 'linear-gradient(135deg, rgba(76,201,255,0.18) 0%, rgba(122,92,255,0.12) 100%)',
  },
  {
    id: 'evt-2',
    slug: 'resident-mixer-april',
    title: 'Resident Mixer — Spring Edition',
    date: 'Friday, April 4, 2026',
    time: '7:00 PM',
    endTime: '9:30 PM',
    location: 'Tower 2 Sky Lounge, Level 32',
    description:
      'A casual evening mixer for residents of both towers. Light bites, drinks, and good conversation. A great opportunity to meet your neighbors and connect with the broader Panorama community. RSVP appreciated but not required.',
    category: 'Social',
    attendeeCount: 38,
    maxAttendees: 60,
    organizer: 'Community Events Committee',
    tags: ['Social', 'Mixer', 'Both Towers', 'Evening'],
    isPrivate: true,
    imageGradient: 'linear-gradient(135deg, rgba(255,61,245,0.15) 0%, rgba(122,92,255,0.12) 100%)',
  },
  {
    id: 'evt-3',
    slug: 'art-show-tower1-lobby',
    title: 'Art Show — Tower 1 Lobby',
    date: 'Sunday, April 6, 2026',
    time: '11:00 AM',
    endTime: '4:00 PM',
    location: 'Tower 1 Main Lobby',
    description:
      'A curated showcase of artwork by Panorama residents. Paintings, photography, and mixed media on display. Meet the artists and enjoy complimentary refreshments. This is a private, resident-only exhibition.',
    category: 'Arts & Culture',
    attendeeCount: 22,
    organizer: 'Isabelle Fontaine',
    tags: ['Art', 'Exhibition', 'Tower 1', 'Culture'],
    isPrivate: true,
    imageGradient: 'linear-gradient(135deg, rgba(240,168,50,0.15) 0%, rgba(255,61,245,0.10) 100%)',
  },
  {
    id: 'evt-4',
    slug: 'dog-owners-meetup',
    title: 'Dog Owners Meetup',
    date: 'Saturday, April 12, 2026',
    time: '9:00 AM',
    endTime: '10:30 AM',
    location: 'Panorama Courtyard, Ground Level',
    description:
      'Monthly gathering for dog owners in the building. Bring your pup and meet fellow four-legged residents. We\'ll discuss building pet policies, share tips, and let the dogs socialize. All breeds welcome.',
    category: 'Pets',
    attendeeCount: 11,
    maxAttendees: 25,
    organizer: 'Marcus Webb',
    tags: ['Pets', 'Dogs', 'Outdoor', 'Monthly'],
    isPrivate: true,
    imageGradient: 'linear-gradient(135deg, rgba(45,212,160,0.15) 0%, rgba(76,201,255,0.10) 100%)',
  },
  {
    id: 'evt-5',
    slug: 'hiit-fitness-class',
    title: 'HIIT Fitness Class',
    date: 'Wednesday, April 16, 2026',
    time: '6:30 PM',
    endTime: '7:30 PM',
    location: 'Tower 2 Fitness Center, Level 3',
    description:
      'High-intensity interval training session led by resident trainer James Okafor. 45-minute full-body workout suitable for intermediate to advanced fitness levels. Towels and water provided. Spots are limited — first come, first served.',
    category: 'Fitness & Wellness',
    attendeeCount: 9,
    maxAttendees: 15,
    organizer: 'James Okafor',
    tags: ['HIIT', 'Fitness', 'Tower 2', 'Evening'],
    isPrivate: true,
    imageGradient: 'linear-gradient(135deg, rgba(76,201,255,0.15) 0%, rgba(45,212,160,0.10) 100%)',
  },
  {
    id: 'evt-6',
    slug: 'new-resident-welcome-social',
    title: 'New Resident Welcome Social',
    date: 'Thursday, April 24, 2026',
    time: '6:00 PM',
    endTime: '8:00 PM',
    location: 'Tower 1 Amenity Lounge, Level 5',
    description:
      'A warm welcome event for residents who have joined Panorama Towers in the last six months. Meet your neighbors, learn about building amenities, and get connected with the community. Hosted by the Panorama Resident Committee.',
    category: 'Social',
    attendeeCount: 17,
    maxAttendees: 40,
    organizer: 'Resident Committee',
    tags: ['Welcome', 'New Residents', 'Social', 'Tower 1'],
    isPrivate: true,
    imageGradient: 'linear-gradient(135deg, rgba(122,92,255,0.18) 0%, rgba(76,201,255,0.12) 100%)',
  },
  {
    id: 'evt-7',
    slug: 'rooftop-stargazing-night',
    title: 'Rooftop Stargazing Night',
    date: 'Saturday, May 3, 2026',
    time: '9:00 PM',
    endTime: '11:00 PM',
    location: 'Tower 2 Rooftop Terrace, Level 40',
    description:
      'Join fellow residents for an evening of stargazing from the rooftop. Telescopes will be available. Bring a blanket and enjoy the city skyline and clear skies. Light refreshments provided.',
    category: 'Social',
    attendeeCount: 26,
    maxAttendees: 35,
    organizer: 'Lena Vasquez',
    tags: ['Rooftop', 'Stargazing', 'Evening', 'Tower 2'],
    isPrivate: true,
    imageGradient: 'linear-gradient(135deg, rgba(122,92,255,0.20) 0%, rgba(255,61,245,0.08) 100%)',
  },
  {
    id: 'evt-8',
    slug: 'book-club-april',
    title: 'Resident Book Club — April Session',
    date: 'Tuesday, April 22, 2026',
    time: '7:00 PM',
    endTime: '8:30 PM',
    location: 'Tower 1 Library Nook, Level 6',
    description:
      'Monthly book club discussion. This month\'s read: "Tomorrow, and Tomorrow, and Tomorrow" by Gabrielle Zevin. All residents welcome, whether you finished the book or not. Wine and light snacks provided.',
    category: 'Arts & Culture',
    attendeeCount: 8,
    maxAttendees: 16,
    organizer: 'Sophia Nakamura',
    tags: ['Book Club', 'Monthly', 'Tower 1', 'Evening'],
    isPrivate: true,
    imageGradient: 'linear-gradient(135deg, rgba(240,168,50,0.12) 0%, rgba(122,92,255,0.10) 100%)',
  },
];

export function getEventBySlug(slug: string): Event | undefined {
  return mockEvents.find((e) => e.slug === slug);
}
